var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLotus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 241.9 244",
    style: {
      enableBackground: "new 0 0 241.9 244"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#253668;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -628.8,
    y: -624.7,
    className: "st0",
    width: 1200,
    height: 1200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.3,481.3c4.5,8.5,31.3,25.1,48.2,28.2c11.1,2,37-4.5,39.5-10.7c-8.5,1.8-48-8.6-62.8-32.2 c-13.1-24.6-2.4-64,3.3-70.5c-6.6-0.9-25.2,18.3-28.9,28.9c-5.7,16.2-4.7,47.8,0.5,55.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.1,321.2c-9.6-0.4-37.4,14.6-48.6,27.6c-7.3,8.6-14.6,34.3-10.5,39.5c2.7-8.2,31.5-37.2,59.3-38.2 c27.9,0.9,56.7,29.9,59.4,38.1c4.1-5.2-3.2-30.9-10.6-39.5c-11.1-13-39-28-48.6-27.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M512.8,480.7c5.2-8.1,6.1-39.7,0.3-55.9c-3.8-10.7-22.4-29.8-29-28.9c5.8,6.5,16.5,45.9,3.5,70.5 c-14.7,23.7-54.3,34.1-62.7,32.4c2.5,6.2,28.4,12.6,39.5,10.6c16.9-3.1,43.7-19.8,48.2-28.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,501.4c-4.2,6.7-27.8,15.5-40.2,14.8c14.8,8.3,30.8,14.2,40.2,13.6c9.4,0.7,25.3-5.3,40.2-13.6 C448.3,516.9,424.7,508.1,420.4,501.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M356.5,391c-3.7-7,0.5-31.8,7.3-42.2c-14.6,8.7-27.7,19.6-31.8,28c-5.3,7.8-8.1,24.6-8.3,41.6 C329.2,407.3,348.6,391.3,356.5,391z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M484.1,390.8c7.9,0.3,27.3,16.3,32.9,27.4c-0.2-17-3.1-33.8-8.4-41.6c-4.1-8.5-17.2-19.3-31.9-28 C483.6,359,487.8,383.8,484.1,390.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,496.3C420.4,496.3,420.4,496.3,420.4,496.3c-7,0.3-22.4-2.2-30-7.9c-8.1-6.1-14.7-23.3-11.6-34.6 c6.6,13.1,22.5,22.2,41.7,23.3c19.2-1.2,35-10.3,41.6-23.4c3,11.4-3.5,28.6-11.6,34.7C442.8,494.1,427.4,496.6,420.4,496.3 C420.5,496.3,420.5,496.3,420.4,496.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361,393.5C361,393.5,361,393.5,361,393.5c3.2-6.2,13.1-18.3,21.9-22c9.3-4,27.5-1,35.8,7.2 c-14.7-0.8-30.4,8.4-41,24.4c-8.5,17.2-8.6,35.5-0.5,47.8c-11.4-3-23-17.3-24.2-27.4C351.7,414,357.2,399.4,361,393.5 C361,393.6,361,393.5,361,393.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M479.7,393.4C479.7,393.4,479.7,393.4,479.7,393.4c3.8,5.9,9.3,20.5,8.2,30c-1.2,10-12.8,24.3-24.2,27.4 c8-12.3,8-30.6-0.6-47.8c-10.6-16-26.4-25.2-41.1-24.3c8.3-8.3,26.5-11.2,35.8-7.3C466.6,375.1,476.5,387.2,479.7,393.4 C479.7,393.4,479.7,393.4,479.7,393.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M376,453.4c-2.8,6.5-1.1,22.8,5.1,30c-10.2-2-20.2-11.4-24.5-18.8c-4.3-7.4-7.4-20.8-4.1-30.6 C355.6,443,368.9,452.6,376,453.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.3,376.4c-4.3-5.7-19.2-12.4-28.6-10.6c6.8-7.8,20-11.8,28.5-11.8c8.6,0,21.7,4,28.6,11.8 C439.5,364,424.6,370.7,420.3,376.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M464.8,453.4c7-0.9,20.3-10.4,23.5-19.4c3.3,9.8,0.2,23.2-4,30.6c-4.3,7.4-14.3,16.8-24.5,18.9 C466,476.2,467.6,459.9,464.8,453.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M381.6,450.3c10.3,20.1,31.1,12.8,37.1,2.3c-8.9,2.8-19.7,0.8-25.7-9c-5.6-10.1-1.9-20.4,5-26.8 c-12-0.1-28.8,14.3-16.5,33.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.2,382.9c-22.6-1.2-26.6,20.6-20.5,31c2-9.1,9.1-17.5,20.7-17.7c11.5,0.2,18.6,8.6,20.7,17.7 c6.1-10.4,2-32.1-20.6-30.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M459.3,450c12.3-19-4.5-33.3-16.5-33.2c6.8,6.3,10.5,16.6,5,26.7c-6,9.9-16.8,11.8-25.6,9.1 c6,10.4,26.8,17.8,37.1-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,454.3c-4.8,6.6-11.6,12.7-17.8,13.3c5.6,3.1,11.7,4.7,17.8,4.7c6.1,0,12.2-1.6,17.8-4.7 C432,466.9,425.2,460.9,420.4,454.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M397.4,414.5c-3.4-7.5-5.2-16.3-2.6-22.1c-5.5,3.3-9.9,7.8-13,13.1c-3,5.3-4.7,11.3-4.8,17.8 C380.6,418.2,389.2,415.4,397.4,414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M443.3,414.5c8.1,0.8,16.7,3.7,20.4,8.8c-0.1-6.5-1.8-12.5-4.9-17.8s-7.5-9.8-13-13.1 C448.5,398.1,446.7,407,443.3,414.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.9,418.1c1.5-11.4-10.5-18.2-16.6-11.5c-6.1-6.7-18.1,0.1-16.6,11.5c-10.9,4.9-10.9,18.7-1.7,20.1 c-3,9.2,8.9,16.1,18.3,8.6c9.4,7.5,21.3,0.6,18.2-8.6C447.8,436.7,447.9,423,436.9,418.1z M427,431.6c0.3,4.4-3.5,5.5-6.6,3.1 c-3.1,2.4-6.9,1.2-6.6-3.1c-3.8-1.8-2.9-5.6,0.6-7.3c-0.4-3.7,2.5-6.5,6-4.2c3.5-2.3,6.4,0.5,6,4.2 C429.9,426,430.9,429.8,427,431.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-477.9,244c6-6.4,20.8-29.2,15.7-51.1c-3.1-13.3-11.4-15.9-15.7-15.9c-4.3,0-12.6,2.6-15.7,15.9 C-498.8,214.8-483.9,237.6-477.9,244z M-543.4,224.8c8.5-2.2,33.3-13.3,40.8-34.5c4.6-12.9-1-19.6-4.6-21.9 c-3.6-2.3-12-4.6-21.8,4.9C-545.1,189-544.9,216.1-543.4,224.8z M-588,173.2c8.3,2.8,35.2,6.8,53-6.9c10.8-8.4,9.7-17,8-20.9 c-1.8-3.9-7.6-10.4-21-7.7C-570.1,142.2-584.7,165.1-588,173.2z M-597.8,105.7c5.5,6.8,26,24.8,48.3,22.8 c13.6-1.2,17.4-9,18-13.3s-0.8-12.8-13.5-17.8C-565.9,89.3-590.5,100.7-597.8,105.7z M-569.4,43.7c1,8.8,8.4,34.9,28.3,45.3 c12.1,6.3,19.5,1.8,22.3-1.4c2.8-3.2,6.3-11.2-1.8-22.3C-533.7,47.1-560.6,43.4-569.4,43.7z M-512,6.8 c-3.9,7.9-11.8,33.9-0.7,53.4c6.7,11.9,15.4,12.1,19.5,10.9c4.1-1.2,11.3-6.1,10.6-19.7C-483.8,29-504.5,11.3-512,6.8z  M-443.8,6.8c-7.6,4.5-28.2,22.2-29.5,44.6c-0.8,13.6,6.5,18.5,10.6,19.7s12.8,1,19.5-10.8C-432.1,40.7-439.9,14.7-443.8,6.8z  M-386.5,43.7c-8.8-0.3-35.7,3.4-48.9,21.6c-8,11.1-4.6,19-1.8,22.3c2.8,3.2,10.2,7.8,22.3,1.4 C-394.9,78.6-387.4,52.4-386.5,43.7z M-358.1,105.7c-7.2-5-31.9-16.5-52.8-8.3c-12.7,5-14.1,13.6-13.5,17.8 c0.6,4.2,4.4,12.1,18,13.3C-384.1,130.5-363.6,112.6-358.1,105.7z M-367.8,173.2c-3.4-8.1-17.9-31.1-39.9-35.5 c-13.4-2.7-19.2,3.8-21,7.7c-1.8,3.9-2.9,12.5,8,20.9C-403,180.1-376.2,176-367.8,173.2z M-412.5,224.8 c1.5-8.7,1.7-35.8-14.4-51.4c-9.8-9.5-18.2-7.2-21.8-4.9s-9.2,9-4.6,21.9C-445.8,211.5-421,222.6-412.5,224.8z M-477.9,183 c7.9,0,13.6,13.5,0,38.8C-491.5,196.5-485.8,183-477.9,183z M-510.4,173.5c6.6,4.2,4.1,18.7-21,32.7 C-529.2,177.5-517,169.2-510.4,173.5z M-532.6,147.9c3.3,7.2-6.7,18-35.3,16.1C-550.5,141.1-535.8,140.7-532.6,147.9z  M-537.4,114.4c-1.1,7.8-15.3,11.5-38.4-5.5C-548.8,99-536.2,106.6-537.4,114.4z M-523.3,83.6c-5.2,5.9-19.1,1.4-29.3-25.4 C-524.6,64.5-518.2,77.7-523.3,83.6z M-494.9,65.3c-7.5,2.2-16.9-9.2-10.9-37.3C-485.6,48.5-487.3,63.1-494.9,65.3z M-461,65.3 c-7.5-2.2-9.2-16.8,10.9-37.3C-444.2,56.2-453.5,67.6-461,65.3z M-432.5,83.6c-5.1-5.9,1.3-19.1,29.4-25.4 C-413.4,85-427.4,89.6-432.5,83.6z M-418.5,114.4c-1.1-7.8,11.5-15.4,38.4-5.5C-403.2,125.9-417.4,122.2-418.5,114.4z  M-423.3,147.9c3.3-7.2,18-6.7,35.3,16.1C-416.6,165.9-426.6,155.1-423.3,147.9z M-445.5,173.5c6.6-4.3,18.8,4,21,32.7 C-449.6,192.2-452.1,177.7-445.5,173.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-477.9,244c6-6.4,20.8-29.2,15.7-51.1c-3.1-13.3-11.4-15.9-15.7-15.9c-4.3,0-12.6,2.6-15.7,15.9 C-498.8,214.8-483.9,237.6-477.9,244z M-543.4,224.8c8.5-2.2,33.3-13.3,40.8-34.5c4.6-12.9-1-19.6-4.6-21.9 c-3.6-2.3-12-4.6-21.8,4.9C-545.1,189-544.9,216.1-543.4,224.8z M-588,173.2c8.3,2.8,35.2,6.8,53-6.9c10.8-8.4,9.7-17,8-20.9 c-1.8-3.9-7.6-10.4-21-7.7C-570.1,142.2-584.7,165.1-588,173.2z M-597.8,105.7c5.5,6.8,26,24.8,48.3,22.8 c13.6-1.2,17.4-9,18-13.3s-0.8-12.8-13.5-17.8C-565.9,89.3-590.5,100.7-597.8,105.7z M-569.4,43.7c1,8.8,8.4,34.9,28.3,45.3 c12.1,6.3,19.5,1.8,22.3-1.4c2.8-3.2,6.3-11.2-1.8-22.3C-533.7,47.1-560.6,43.4-569.4,43.7z M-512,6.8 c-3.9,7.9-11.8,33.9-0.7,53.4c6.7,11.9,15.4,12.1,19.5,10.9c4.1-1.2,11.3-6.1,10.6-19.7C-483.8,29-504.5,11.3-512,6.8z  M-443.8,6.8c-7.6,4.5-28.2,22.2-29.5,44.6c-0.8,13.6,6.5,18.5,10.6,19.7s12.8,1,19.5-10.8C-432.1,40.7-439.9,14.7-443.8,6.8z  M-386.5,43.7c-8.8-0.3-35.7,3.4-48.9,21.6c-8,11.1-4.6,19-1.8,22.3c2.8,3.2,10.2,7.8,22.3,1.4 C-394.9,78.6-387.4,52.4-386.5,43.7z M-358.1,105.7c-7.2-5-31.9-16.5-52.8-8.3c-12.7,5-14.1,13.6-13.5,17.8 c0.6,4.2,4.4,12.1,18,13.3C-384.1,130.5-363.6,112.6-358.1,105.7z M-367.8,173.2c-3.4-8.1-17.9-31.1-39.9-35.5 c-13.4-2.7-19.2,3.8-21,7.7c-1.8,3.9-2.9,12.5,8,20.9C-403,180.1-376.2,176-367.8,173.2z M-412.5,224.8 c1.5-8.7,1.7-35.8-14.4-51.4c-9.8-9.5-18.2-7.2-21.8-4.9s-9.2,9-4.6,21.9C-445.8,211.5-421,222.6-412.5,224.8z M-477.9,183 c7.9,0,13.6,13.5,0,38.8C-491.5,196.5-485.8,183-477.9,183z M-510.4,173.5c6.6,4.2,4.1,18.7-21,32.7 C-529.2,177.5-517,169.2-510.4,173.5z M-532.6,147.9c3.3,7.2-6.7,18-35.3,16.1C-550.5,141.1-535.8,140.7-532.6,147.9z  M-537.4,114.4c-1.1,7.8-15.3,11.5-38.4-5.5C-548.8,99-536.2,106.6-537.4,114.4z M-523.3,83.6c-5.2,5.9-19.1,1.4-29.3-25.4 C-524.6,64.5-518.2,77.7-523.3,83.6z M-494.9,65.3c-7.5,2.2-16.9-9.2-10.9-37.3C-485.6,48.5-487.3,63.1-494.9,65.3z M-461,65.3 c-7.5-2.2-9.2-16.8,10.9-37.3C-444.2,56.2-453.5,67.6-461,65.3z M-432.5,83.6c-5.1-5.9,1.3-19.1,29.4-25.4 C-413.4,85-427.4,89.6-432.5,83.6z M-418.5,114.4c-1.1-7.8,11.5-15.4,38.4-5.5C-403.2,125.9-417.4,122.2-418.5,114.4z  M-423.3,147.9c3.3-7.2,18-6.7,35.3,16.1C-416.6,165.9-426.6,155.1-423.3,147.9z M-445.5,173.5c6.6-4.3,18.8,4,21,32.7 C-449.6,192.2-452.1,177.7-445.5,173.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-477.9,244c6-6.4,20.8-29.2,15.7-51.1c-3.1-13.3-11.4-15.9-15.7-15.9c-4.3,0-12.6,2.6-15.7,15.9 C-498.8,214.8-483.9,237.6-477.9,244z M-543.4,224.8c8.5-2.2,33.3-13.3,40.8-34.5c4.6-12.9-1-19.6-4.6-21.9 c-3.6-2.3-12-4.6-21.8,4.9C-545.1,189-544.9,216.1-543.4,224.8z M-588,173.2c8.3,2.8,35.2,6.8,53-6.9c10.8-8.4,9.7-17,8-20.9 c-1.8-3.9-7.6-10.4-21-7.7C-570.1,142.2-584.7,165.1-588,173.2z M-597.8,105.7c5.5,6.8,26,24.8,48.3,22.8 c13.6-1.2,17.4-9,18-13.3s-0.8-12.8-13.5-17.8C-565.9,89.3-590.5,100.7-597.8,105.7z M-569.4,43.7c1,8.8,8.4,34.9,28.3,45.3 c12.1,6.3,19.5,1.8,22.3-1.4c2.8-3.2,6.3-11.2-1.8-22.3C-533.7,47.1-560.6,43.4-569.4,43.7z M-512,6.8 c-3.9,7.9-11.8,33.9-0.7,53.4c6.7,11.9,15.4,12.1,19.5,10.9c4.1-1.2,11.3-6.1,10.6-19.7C-483.8,29-504.5,11.3-512,6.8z  M-443.8,6.8c-7.6,4.5-28.2,22.2-29.5,44.6c-0.8,13.6,6.5,18.5,10.6,19.7s12.8,1,19.5-10.8C-432.1,40.7-439.9,14.7-443.8,6.8z  M-386.5,43.7c-8.8-0.3-35.7,3.4-48.9,21.6c-8,11.1-4.6,19-1.8,22.3c2.8,3.2,10.2,7.8,22.3,1.4 C-394.9,78.6-387.4,52.4-386.5,43.7z M-358.1,105.7c-7.2-5-31.9-16.5-52.8-8.3c-12.7,5-14.1,13.6-13.5,17.8 c0.6,4.2,4.4,12.1,18,13.3C-384.1,130.5-363.6,112.6-358.1,105.7z M-367.8,173.2c-3.4-8.1-17.9-31.1-39.9-35.5 c-13.4-2.7-19.2,3.8-21,7.7c-1.8,3.9-2.9,12.5,8,20.9C-403,180.1-376.2,176-367.8,173.2z M-412.5,224.8 c1.5-8.7,1.7-35.8-14.4-51.4c-9.8-9.5-18.2-7.2-21.8-4.9s-9.2,9-4.6,21.9C-445.8,211.5-421,222.6-412.5,224.8z M-477.9,183 c7.9,0,13.6,13.5,0,38.8C-491.5,196.5-485.8,183-477.9,183z M-510.4,173.5c6.6,4.2,4.1,18.7-21,32.7 C-529.2,177.5-517,169.2-510.4,173.5z M-532.6,147.9c3.3,7.2-6.7,18-35.3,16.1C-550.5,141.1-535.8,140.7-532.6,147.9z  M-537.4,114.4c-1.1,7.8-15.3,11.5-38.4-5.5C-548.8,99-536.2,106.6-537.4,114.4z M-523.3,83.6c-5.2,5.9-19.1,1.4-29.3-25.4 C-524.6,64.5-518.2,77.7-523.3,83.6z M-494.9,65.3c-7.5,2.2-16.9-9.2-10.9-37.3C-485.6,48.5-487.3,63.1-494.9,65.3z M-461,65.3 c-7.5-2.2-9.2-16.8,10.9-37.3C-444.2,56.2-453.5,67.6-461,65.3z M-432.5,83.6c-5.1-5.9,1.3-19.1,29.4-25.4 C-413.4,85-427.4,89.6-432.5,83.6z M-418.5,114.4c-1.1-7.8,11.5-15.4,38.4-5.5C-403.2,125.9-417.4,122.2-418.5,114.4z  M-423.3,147.9c3.3-7.2,18-6.7,35.3,16.1C-416.6,165.9-426.6,155.1-423.3,147.9z M-445.5,173.5c6.6-4.3,18.8,4,21,32.7 C-449.6,192.2-452.1,177.7-445.5,173.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-477.9,173.1c27.6,0,50-22.4,50-49.9s-22.4-49.9-50-49.9c-27.6,0-50,22.4-50,49.9 C-527.9,150.7-505.5,173.1-477.9,173.1z M-477.9,80.2c23.7,0,42.9,19.2,42.9,42.9s-19.2,42.9-42.9,42.9 c-23.7,0-42.9-19.2-42.9-42.9S-501.6,80.2-477.9,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-481.2,131.1h7.3c0.6,0,1.2-0.3,1.5-0.9l3.7-6.3c0.3-0.5,0.3-1.2,0-1.7l-3.7-6.3c-0.3-0.5-0.9-0.8-1.5-0.8 h-7.3c-0.6,0-1.2,0.3-1.5,0.8l-3.7,6.3c-0.3,0.5-0.3,1.2,0,1.7l3.7,6.3C-482.4,130.8-481.8,131.1-481.2,131.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-485.9,143l3.4,5.8c0.3,0.6,0.9,0.9,1.6,0.9h6.7c0.7,0,1.3-0.4,1.6-0.9l3.4-5.8c0.3-0.6,0.3-1.3,0-1.9 l-3.4-5.8c-0.3-0.6-0.9-0.9-1.6-0.9h-6.7c-0.7,0-1.3,0.4-1.6,0.9l-3.4,5.8C-486.2,141.7-486.2,142.4-485.9,143z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-473.3,153.3c-0.4-0.7-1.1-1.1-1.9-1.1h-4.7c-0.8,0-1.5,0.4-1.9,1.1l-2.4,4.1c-0.4,0.7-0.4,1.5,0,2.2 l1.9,3.3c0.7,1.1,1.9,1.9,3.2,1.9h2.9c1.4,0,2.6-0.7,3.3-1.9l1.9-3.2c0.4-0.7,0.4-1.5,0-2.2L-473.3,153.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-472.7,97.7c-0.3-0.5-0.9-0.9-1.5-0.9h-6.9c-0.6,0-1.2,0.3-1.5,0.9l-3.4,5.9c-0.3,0.5-0.3,1.2,0,1.7 l3.4,5.9c0.3,0.5,0.9,0.9,1.5,0.9h6.9c0.6,0,1.2-0.3,1.5-0.9l3.4-5.9c0.3-0.5,0.3-1.2,0-1.7L-472.7,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-515.3,129.5c0.7,1.2,1.9,1.9,3.2,1.9h6.1c0.8,0,1.5-0.4,1.9-1.1l3.5-6c0.4-0.7,0.4-1.5,0-2.2l-3.5-6 c-0.4-0.7-1.1-1.1-1.9-1.1h-6.1c-1.3,0-2.6,0.7-3.2,1.9C-517.6,120.7-517.6,125.5-515.3,129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-443.1,115.1h-5.9c-0.8,0-1.5,0.4-1.9,1.1l-3.4,5.8c-0.4,0.7-0.4,1.5,0,2.2l3.4,5.8 c0.4,0.7,1.1,1.1,1.9,1.1h5.9c1.3,0,2.5-0.7,3.2-1.9c2.2-3.8,2.2-8.6,0-12.4C-440.5,115.8-441.7,115.1-443.1,115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-488.5,143.8c-0.4-0.7-1.1-1.1-1.9-1.1h-7c-0.8,0-1.5,0.4-1.9,1.1l-3,5.3c-0.7,1.1-0.7,2.6,0,3.7 c2.3,3.9,6.5,6.4,11,6.4c1.3,0,2.5-0.7,3.2-1.9l3-5.3c0.4-0.7,0.4-1.5,0-2.2L-488.5,143.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-470.3,96l3.4,5.8c0.4,0.7,1.1,1.1,1.9,1.1h6.7c0.8,0,1.5-0.4,1.9-1.1l2.9-5.1c0.7-1.2,0.7-2.6,0-3.8 l-1.4-2.4c-1.3-2.3-3.8-3.7-6.5-3.7h-2.8c-1.3,0-2.6,0.7-3.2,1.9l-2.9,5.1C-470.7,94.5-470.7,95.3-470.3,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-456.2,144.1c-0.4-0.7-1.1-1.1-1.9-1.1h-7c-0.8,0-1.5,0.4-1.9,1.1l-3.5,6c-0.4,0.7-0.4,1.5,0,2.2l3,5.3 c0.7,1.1,1.9,1.9,3.2,1.9c4.6,0,8.8-2.4,11.1-6.4c0.7-1.1,0.7-2.6,0-3.7L-456.2,144.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-499,102.2c0.4,0.7,1.1,1.1,1.9,1.1h6.7c0.8,0,1.5-0.4,1.9-1.1l3.4-5.8c0.4-0.7,0.4-1.5,0-2.2l-2.9-5.1 c-0.7-1.2-1.9-1.9-3.2-1.9c-4.4,0-8.5,2.3-10.7,6.2c-0.7,1.2-0.7,2.6,0,3.8L-499,102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-482,93.5c0.4,0.7,1.1,1.1,1.9,1.1h5.1c0.8,0,1.5-0.4,1.9-1.1l2.5-4.4c0.4-0.7,0.4-1.5,0-2.2l-2.1-3.6 c-0.7-1.1-1.9-1.8-3.2-1.8h-3.4c-1.3,0-2.5,0.7-3.2,1.8l-2.1,3.6c-0.4,0.7-0.4,1.5,0,2.2L-482,93.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-464.6,140.2h6.9c0.6,0,1.2-0.3,1.5-0.9l3.4-5.9c0.3-0.5,0.3-1.2,0-1.7l-3.4-5.9c-0.3-0.5-0.9-0.9-1.5-0.9 h-6.9c-0.6,0-1.2,0.3-1.5,0.9l-3.4,5.9c-0.3,0.5-0.3,1.2,0,1.7l3.4,5.9C-465.8,139.9-465.2,140.2-464.6,140.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-442.7,135.6c-0.4-0.7-1.1-1.1-1.9-1.1h-4.7c-0.8,0-1.5,0.4-1.9,1.1l-2.4,4.1c-0.4,0.7-0.4,1.5,0,2.2 l2.4,4.1c0.4,0.7,1.1,1.1,1.9,1.1h3.8c1.3,0,2.5-0.7,3.2-1.9l1.5-2.6c0.7-1.1,0.7-2.6,0-3.7L-442.7,135.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-490.3,106.1h-6.9c-0.6,0-1.2,0.3-1.5,0.9l-3.4,5.9c-0.3,0.5-0.3,1.2,0,1.7l3.4,5.9 c0.3,0.5,0.9,0.9,1.5,0.9h6.9c0.6,0,1.2-0.3,1.5-0.9l3.4-5.9c0.3-0.5,0.3-1.2,0-1.7l-3.4-5.9 C-489.1,106.4-489.6,106.1-490.3,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-512.4,111.1c0.4,0.7,1.1,1.1,1.9,1.1h5.1c0.8,0,1.5-0.4,1.9-1.1l2.5-4.4c0.4-0.7,0.4-1.5,0-2.2l-2.5-4.4 c-0.4-0.7-1.1-1.1-1.9-1.1h-4.2c-1.3,0-2.5,0.7-3.2,1.8l-1.7,2.9c-0.7,1.1-0.7,2.6,0,3.7L-512.4,111.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-452.8,112.8l-3.4-5.9c-0.3-0.5-0.9-0.9-1.5-0.9h-6.9c-0.6,0-1.2,0.3-1.5,0.9l-3.4,5.9 c-0.3,0.5-0.3,1.2,0,1.7l3.4,5.9c0.3,0.5,0.9,0.9,1.5,0.9h6.9c0.6,0,1.2-0.3,1.5-0.9l3.4-5.9 C-452.5,113.9-452.5,113.3-452.8,112.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-453.5,106.5l2.4,4.1c0.4,0.7,1.1,1.1,1.9,1.1h4.7c0.8,0,1.5-0.4,1.9-1.1l1.9-3.3c0.7-1.1,0.7-2.6,0-3.7 l-1.5-2.5c-0.7-1.2-2-1.9-3.3-1.9h-3.8c-0.8,0-1.5,0.4-1.9,1.1l-2.4,4.1C-453.9,105-453.9,105.8-453.5,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-502,133.2l3.4,5.9c0.3,0.5,0.9,0.9,1.5,0.9h6.9c0.6,0,1.2-0.3,1.5-0.9l3.4-5.9c0.3-0.5,0.3-1.2,0-1.7 l-3.4-5.9c-0.3-0.5-0.9-0.9-1.5-0.9h-6.9c-0.6,0-1.2,0.3-1.5,0.9l-3.4,5.9C-502.4,132.1-502.4,132.7-502,133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-501,139.5l-2.5-4.4c-0.4-0.7-1.1-1.1-1.9-1.1h-5.1c-0.8,0-1.5,0.4-1.9,1.1l-2.1,3.6 c-0.7,1.1-0.7,2.6,0,3.7l1.7,2.9c0.7,1.1,1.9,1.9,3.2,1.9h4.2c0.8,0,1.5-0.4,1.9-1.1l2.5-4.4C-500.5,141-500.5,140.2-501,139.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-454.1,419.1c36.2,4.6,71.1,4.9,90.5-50.9c-10,8.4-30.2,11.9-51.2,17.1c15.1-15.6,28.2-31.3,40.4-35.8 c-58-11.1-75.2,19.3-89.3,52.9c19.2-52.4,3.5-73.1-14.2-99c-17.8,25.9-33.4,46.6-14.2,99c-14.1-33.6-31.3-64.1-89.3-52.9 c12.3,4.5,25.3,20.2,40.4,35.8c-21-5.3-41.2-8.7-51.2-17.1c19.3,55.8,54.3,55.5,90.5,50.9c-54.9,9.6-65.1,33.5-78.6,61.9 c31.3,2.4,57.1,5.6,92.9-37.2c-22.1,29-39.8,59.1-1.2,103.8c-2.2-12.9,4.8-32.1,10.8-52.9c6,20.9,13,40,10.8,52.9 c38.6-44.6,20.9-74.7-1.2-103.8c35.8,42.8,61.6,39.6,92.9,37.2C-389,452.6-399.1,428.7-454.1,419.1z M-399.6,360.9 c-11.8,11.7-24.8,26.9-39.6,38.5c17.5-7.1,37.1-10.7,53.2-15.1c-18.9,30-46.4,30.6-74.5,27.4C-449.2,385.8-435,362.3-399.6,360.9z  M-477.9,328.9c25.7,26.7,9.6,64.2,0,81.9C-487.6,393.1-503.7,355.6-477.9,328.9z M-471.3,422.5c0,3.7-3,6.6-6.6,6.6 s-6.6-3-6.6-6.6s3-6.6,6.6-6.6C-474.3,415.9-471.3,418.8-471.3,422.5z M-569.8,384.4c16,4.4,35.7,8,53.2,15.1 c-14.9-11.6-27.8-26.8-39.6-38.5c35.4,1.4,49.7,24.9,61,50.9C-523.5,414.9-550.9,414.3-569.8,384.4z M-558.4,468.2 c10.3-35.6,50.8-40.5,70.9-40.9C-497.9,444.5-522.4,477.1-558.4,468.2z M-464.4,520.1c-4.2-16.1-10.9-34.9-13.5-53.6 c-2.6,18.7-9.3,37.5-13.5,53.6c-16.5-31.4-3.3-55.5,13.5-78.3C-461.1,464.6-447.9,488.8-464.4,520.1z M-468.4,427.3 c20.1,0.5,60.6,5.3,70.9,40.9C-433.5,477.1-457.9,444.5-468.4,427.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-511.4,356.2c0,0-1.3-32.6-22.6-31.4C-551.5,325.8-521.5,340.2-511.4,356.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-533.9,518.8c9.6,14.7,7.1-18.5,15.9-35.3C-518,483.5-545.6,500.9-533.9,518.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-404.4,425.6c0,0,28.9,15.2,38.5-3.9C-358,406.1-385.5,424.8-404.4,425.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-421.9,324.8c-21.3-1.2-22.6,31.4-22.6,31.4C-434.4,340.2-404.4,325.8-421.9,324.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-551.5,425.6c-18.9-0.8-46.4-19.5-38.5-3.9C-580.3,440.8-551.5,425.6-551.5,425.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-437.9,483.5c8.8,16.8,6.3,49.9,15.9,35.3C-410.3,500.9-437.9,483.5-437.9,483.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-477.9-294.9c-10.1,0-36,41.5-39.8,49.1c-10.5,21.2,41,40.2,25,56.3c-16.1,16-35.1-35.5-56.3-25 c-7.6,3.8-49.1,29.7-49.1,39.8s41.5,36,49.1,39.8c21.2,10.5,40.2-41,56.3-25c16,16.1-35.5,35.1-25,56.3 c3.8,7.6,29.7,49.1,39.8,49.1c10.1,0,36-41.5,39.8-49.1c10.5-21.2-41-40.2-25-56.3c16.1-16,35.1,35.5,56.3,25 c7.6-3.8,49.1-29.7,49.1-39.8s-41.5-36-49.1-39.8c-21.2-10.5-40.2,41-56.3,25c-16-16.1,35.5-35.1,25-56.3 C-441.9-253.4-467.8-294.9-477.9-294.9z M-477.9-202.9c-8.3-8.7-25.7-25.6-25.7-34.8c0-5.1,18.9-23.7,25.7-23.7 s25.7,18.6,25.7,23.7C-452.3-228.5-469.6-211.6-477.9-202.9z M-449.7-174.7c8.7-8.3,25.6-25.7,34.8-25.7 c5.1,0,23.7,18.9,23.7,25.7S-409.9-149-415-149C-424.2-149-441-166.4-449.7-174.7z M-477.9-146.5c8.3,8.7,25.7,25.6,25.7,34.8 c0,5.1-18.9,23.7-25.7,23.7s-25.7-18.6-25.7-23.7C-503.6-120.9-486.2-137.8-477.9-146.5z M-506.1-174.7 c-8.7,8.3-25.6,25.7-34.8,25.7c-5.1,0-23.7-18.9-23.7-25.7s18.6-25.7,23.7-25.7C-531.7-200.4-514.9-183-506.1-174.7z M-486.2-183 c4.4-4.4,7.6-10.6,8.3-14.4c0.7,3.8,3.9,10,8.3,14.4c4.4,4.4,10.6,7.6,14.4,8.3c-3.8,0.7-10,3.9-14.4,8.3 c-4.4,4.4-7.6,10.6-8.3,14.4c-0.7-3.8-3.9-10-8.3-14.4c-4.4-4.4-10.6-7.6-14.4-8.3C-496.8-175.4-490.6-178.6-486.2-183z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-541.8-238.6C-541.8-238.6-541.8-238.6-541.8-238.6c-0.2-2.3,1.8-4.1,4-3.8c12.6,1.8,21.4,16.5,29.1,36.9 c-20.5-7.7-35.1-16.6-36.9-29.1C-545.9-236.8-544.1-238.8-541.8-238.6C-541.9-238.6-541.8-238.6-541.8-238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-414-238.6C-414-238.6-414-238.6-414-238.6c2.3-0.2,4.1,1.8,3.8,4c-1.8,12.6-16.5,21.4-36.9,29.1 c7.7-20.5,16.6-35.1,29.1-36.9C-415.8-242.7-413.9-240.9-414-238.6C-414-238.6-414-238.6-414-238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-414-110.8C-414-110.8-414-110.8-414-110.8c0.2,2.3-1.8,4.1-4,3.8c-12.6-1.8-21.4-16.5-29.1-36.9 c20.5,7.7,35.1,16.6,36.9,29.2C-410-112.6-411.8-110.6-414-110.8C-414-110.8-414-110.8-414-110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-541.8-110.8C-541.8-110.8-541.9-110.8-541.8-110.8c-2.3,0.2-4.1-1.8-3.8-4c1.8-12.6,16.5-21.4,36.9-29.1 c-7.7,20.5-16.6,35.1-29.2,36.9C-540-106.7-542-108.5-541.8-110.8C-541.8-110.8-541.8-110.8-541.8-110.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-532.8-229.6c6.5,0,11.9,8.3,17.2,17.2C-524.5-217.8-532.9-223.1-532.8-229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-423-229.6c0,6.6-8.3,11.9-17.2,17.2C-434.9-221.3-429.6-229.6-423-229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-423-119.8c-6.5,0-11.9-8.3-17.2-17.2C-431.4-131.6-423-126.3-423-119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-532.8-119.8c0-6.6,8.3-11.9,17.2-17.2C-521-128.1-526.3-119.8-532.8-119.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-483.4-180.2c1.8-1.8,3.6-3.4,5.5-5c1.9,1.6,3.7,3.3,5.5,5c1.8,1.8,3.4,3.6,5,5.5c-1.6,1.9-3.3,3.7-5,5.5 c-1.8,1.8-3.6,3.4-5.5,5c-1.9-1.6-3.7-3.3-5.5-5c-1.8-1.8-3.4-3.6-5-5.5C-486.9-176.6-485.2-178.4-483.4-180.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-225.8-61.6c9.5-2,13.9-14.5,14.2-34C-225.2-81.7-231.1-69.8-225.8-61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-291.9-128.2c8.2,5.3,20.1-0.4,34.1-14C-277.3-142-289.9-137.7-291.9-128.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-291.6-222c2,9.5,14.5,13.9,34,14.2C-271.5-221.4-283.4-227.3-291.6-222z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-225-288.1c-5.3,8.2,0.4,20.1,14,34.1C-211.2-273.5-215.5-286-225-288.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-131.2-287.8c-9.5,2-13.9,14.5-14.2,34C-131.8-267.7-125.9-279.6-131.2-287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-65.1-221.2c-8.2-5.3-20.2,0.4-34.1,14C-79.7-207.4-67.2-211.7-65.1-221.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-65.4-127.4c-2-9.5-14.6-14-34-14.2C-85.5-128-73.6-122.1-65.4-127.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-132-61.3c5.3-8.2-0.4-20.1-14-34.1C-145.8-75.9-141.5-63.3-132-61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.7-95.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.9-95.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99.2-141.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-99-207.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-145.3-254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-211.1-254.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-257.8-207.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-258-142.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-296.6-175.1c15.8,10.4-17.3,38.5,50,28.4c-55,40-11.8,36.8-15.6,55.3c18.5-3.8,15,39.4,55.4-15.3 c-10.6,67.2,17.7,34.3,28,50.2c10.4-15.7,38.5,17.3,28.4-50c40,55,36.8,11.8,55.3,15.7c-3.8-18.5,39.4-15-15.3-55.4 c67.2,10.6,34.3-17.7,50.2-28c-15.7-10.4,17.3-38.5-50-28.4c55-40,11.8-36.8,15.7-55.3c-18.5,3.8-15-39.4-55.4,15.3 c10.6-67.2-17.7-34.3-28-50.2c-10.4,15.8-38.5-17.3-28.4,50c-40-55-36.8-11.8-55.3-15.6c3.8,18.5-39.4,15,15.3,55.4 C-313.6-213.7-280.8-185.4-296.6-175.1z M-192.2-180.4c-53.1-22.6-57.2-46-28.8-37.1c-8.8-28.4,14.6-24.2,36.9,29.1 c-21.6-53.6-7.9-73,5.8-46.6c13.9-26.3,27.4-6.8,5.5,46.6c22.6-53.1,46-57.2,37.1-28.8c28.4-8.8,24.2,14.6-29.1,36.9 c53.6-21.6,73-7.9,46.6,5.8c26.3,13.9,6.8,27.4-46.6,5.5c53.1,22.6,57.2,46,28.8,37.1c8.8,28.4-14.6,24.2-36.9-29.1 c21.6,53.6,7.9,73-5.8,46.6c-13.9,26.3-27.4,6.8-5.5-46.6c-22.6,53.1-46,57.2-37.1,28.8c-28.4,8.8-24.2-14.6,29.1-36.9 c-53.6,21.6-73,7.9-46.6-5.8C-265.1-188.8-245.6-202.4-192.2-180.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: -178.5,
    cy: -174.7,
    rx: 24,
    ry: 24
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.3-452.7c24.6,4.6,46.6-8.6,67.6-22.1c-21-13.5-43-26.7-67.6-22.1c20.7-14.1,26.9-39.1,32.2-63.4 c-24.3,5.3-49.3,11.5-63.4,32.2c4.6-24.6-8.6-46.6-22.1-67.6c-13.5,21-26.7,43-22.1,67.6c-14.1-20.7-39.1-26.9-63.4-32.2 c5.3,24.3,11.5,49.3,32.2,63.4C43-501.5,21-488.3,0-474.8c21,13.5,43,26.7,67.6,22.1c-20.7,14.1-26.9,39.1-32.2,63.4 c24.3-5.3,49.3-11.5,63.4-32.2c-4.6,24.6,8.6,46.6,22.1,67.6c13.5-21,26.7-43,22.1-67.6c14.1,20.7,39.1,26.9,63.4,32.2 C201.1-413.6,194.9-438.6,174.3-452.7z M220.3-474.8c-20.4,14.7-51,19.4-85.9,0C169.3-494.2,199.9-489.5,220.3-474.8z M191.2-545 c-4,24.8-22.3,49.8-60.7,60.7C141.4-522.7,166.4-541,191.2-545z M129.5-466.2c-1.8-0.4-4.7,0.8-4.7,0.8s-2.9,1.2-3.9,2.8 c-1-1.6-3.9-2.8-3.9-2.8s-2.9-1.2-4.7-0.8c0.4-1.8-0.8-4.7-0.8-4.7s-1.2-2.9-2.8-3.9c1.6-1,2.8-3.9,2.8-3.9s1.2-2.9,0.8-4.7 c1.8,0.4,4.7-0.8,4.7-0.8s2.9-1.2,3.9-2.8c1,1.6,3.9,2.8,3.9,2.8s2.9,1.2,4.7,0.8c-0.4,1.8,0.8,4.7,0.8,4.7s1.2,2.9,2.8,3.9 c-1.6,1-2.8,3.9-2.8,3.9S129.1-468,129.5-466.2z M120.9-574.2c14.7,20.4,19.4,51,0,85.9C101.6-523.2,106.2-553.8,120.9-574.2z  M50.7-545c24.8,4,49.8,22.3,60.7,60.7C73-495.3,54.7-520.2,50.7-545z M21.6-474.8c20.4-14.7,51-19.4,85.9,0 C72.6-455.4,42-460.1,21.6-474.8z M50.7-404.5c4-24.8,22.3-49.8,60.7-60.7C100.4-426.9,75.5-408.6,50.7-404.5z M120.9-375.5 c-14.7-20.4-19.4-51,0-85.9C140.3-426.4,135.6-395.8,120.9-375.5z M130.5-465.3c38.4,11,56.7,35.9,60.7,60.7 C166.4-408.6,141.4-426.9,130.5-465.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93-542.3c1.8-0.8,3-2.6,3-4.7c0-2.9-2.3-5.2-5.2-5.2c-0.6,0-1.2,0.1-1.8,0.3c-0.5,0.2-1,0.6-1.4,1 c-2,2-2,5.3,0,7.4C89-542,91.2-541.6,93-542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.9-542.3c1.8,0.7,4,0.2,5.4-1.2c2-2,2-5.3,0-7.4c-0.4-0.4-0.9-0.8-1.4-1c-0.6-0.2-1.1-0.3-1.8-0.3 c-2.9,0-5.2,2.3-5.2,5.2C145.9-544.9,147.1-543.1,148.9-542.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.6-508.2c-1.5,1.5-1.9,3.6-1.2,5.4c0.8,1.8,2.6,3,4.7,3c2.9,0,5.2-2.3,5.2-5.2c0-0.6-0.1-1.2-0.3-1.8 c-0.2-0.5-0.6-1-1-1.5C195-510.2,191.7-510.2,189.6-508.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M188.4-446.9c-0.6,1.8-0.2,4,1.2,5.4c2,2,5.3,2,7.4,0c0.4-0.4,0.8-0.9,1-1.5c0.2-0.5,0.3-1.1,0.3-1.8 c0-2.9-2.3-5.2-5.2-5.2C191-449.8,189.2-448.6,188.4-446.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.9-407.3c-1.8,0.8-3,2.6-3,4.7c0,2.9,2.3,5.2,5.2,5.2c0.6,0,1.2-0.1,1.8-0.3c0.5-0.2,1-0.6,1.4-1 c2-2,2-5.3,0-7.4C152.9-407.6,150.7-408,148.9-407.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93-407.3c-1.8-0.6-4-0.2-5.4,1.2c-2,2-2,5.3,0,7.4c0.4,0.4,0.9,0.8,1.4,1c0.6,0.2,1.1,0.3,1.8,0.3 c2.9,0,5.2-2.3,5.2-5.2C96-404.7,94.8-406.5,93-407.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.2-441.4c1.5-1.5,1.9-3.6,1.2-5.4c-0.8-1.8-2.6-3-4.7-3c-2.9,0-5.2,2.3-5.2,5.2c0,0.6,0.1,1.2,0.3,1.8 c0.2,0.5,0.6,1,1,1.5C46.9-439.4,50.2-439.4,52.2-441.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.5-502.8c0.7-1.8,0.2-4-1.2-5.4c-2-2-5.3-2-7.4,0c-0.4,0.4-0.8,0.9-1,1.5c-0.2,0.5-0.3,1.1-0.3,1.8 c0,2.9,2.3,5.2,5.2,5.2C50.8-499.8,52.6-501,53.5-502.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.1-477c0,0-0.7-1.6-0.4-2.6c-1,0.2-2.6-0.4-2.6-0.4s-1.6-0.7-2.2-1.5c-0.6,0.9-2.2,1.5-2.2,1.5 s-1.6,0.6-2.6,0.4c0.2,1-0.4,2.6-0.4,2.6s-0.7,1.6-1.5,2.1c0.9,0.5,1.5,2.1,1.5,2.1s0.7,1.6,0.4,2.6c1-0.2,2.6,0.4,2.6,0.4 s1.6,0.7,2.2,1.5c0.6-0.9,2.2-1.5,2.2-1.5s1.6-0.6,2.6-0.4c-0.2-1,0.4-2.6,0.4-2.6s0.7-1.6,1.5-2.1 C126.8-475.4,126.1-477,126.1-477z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-62.7-481.7c-18.7-11.3-38.3-20.2-59.8-16.2c18.1-12.4,25.6-32.6,30.9-53.8c0.7-2.8-0.1-5.8-2.2-7.8 c-2-2-5-2.9-7.8-2.2c-21.2,5.2-41.4,12.8-53.7,30.9c4-21.5-4.9-41.2-16.2-59.8c-1.5-2.5-4.2-4-7.1-4s-5.6,1.5-7.1,4 c-11.3,18.7-20.2,38.3-16.2,59.8c-12.4-18.1-32.6-25.6-53.8-30.9c-2.8-0.7-5.8,0.1-7.8,2.2c-2,2-2.9,5-2.2,7.8 c5.2,21.2,12.8,41.4,30.9,53.7c-21.4-4-40.9,4.8-59.4,15.9c-2.6,1.5-4.1,4.3-4.1,7.3c0,3,1.6,5.8,4.1,7.3 c18.5,11.1,38.1,19.9,59.4,15.9c-17.9,12.3-25.5,32.3-30.8,53.3c-0.7,2.9,0.1,6,2.2,8.1s5.2,3,8.1,2.2c21-5.2,41-12.8,53.3-30.8 c-4,21.4,4.8,40.9,15.9,59.4c1.5,2.6,4.3,4.1,7.3,4.1c3,0,5.8-1.6,7.3-4.1c11.1-18.5,19.9-38.1,15.9-59.4 c12.4,18.1,32.6,25.6,53.8,30.9c2.8,0.7,5.8-0.1,7.8-2.2c2-2,2.9-5,2.2-7.8c-5.2-21.2-12.8-41.4-30.9-53.7 c21.5,4,41.2-4.9,59.8-16.2c2.5-1.5,4-4.2,4-7.1C-58.7-477.6-60.2-480.2-62.7-481.7z M-123.7-535.2c1.6-0.5,3.2,0,4.4,1.1 s1.6,2.8,1.1,4.4c-5.4,18.6-20.5,36.3-48.3,45.4c-0.8,0.2-1.6,0-2.1-0.5s-0.8-1.4-0.5-2.1C-160-514.7-142.3-529.8-123.7-535.2z  M-169.1-474.8c0,5.2-4.2,9.4-9.4,9.4s-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4S-169.1-480-169.1-474.8z M-182.5-556.3 c0.8-1.4,2.3-2.3,3.9-2.3s3.1,0.9,3.9,2.3c9.3,17,11.2,40.2-2,66.2c-0.4,0.7-1.1,1.1-1.9,1.1s-1.5-0.4-1.9-1.1 C-193.8-516.2-191.9-539.3-182.5-556.3z M-239.1-529.6c-0.5-1.6,0-3.2,1.1-4.4s2.8-1.6,4.4-1.1c18.6,5.4,36.3,20.5,45.4,48.3 c0.2,0.8,0.1,1.6-0.5,2.1c-0.6,0.6-1.4,0.8-2.1,0.5C-218.7-493.3-233.7-511-239.1-529.6z M-260.3-470.8c-1.4-0.8-2.3-2.3-2.3-3.9 s0.9-3.1,2.3-3.9c17-9.3,40.1-11.2,66.2,2c0.7,0.4,1.1,1.1,1.1,1.9s-0.4,1.5-1.1,1.9C-220.1-459.5-243.3-461.4-260.3-470.8z  M-233.6-414.2c-1.6,0.5-3.2,0-4.4-1.1s-1.6-2.8-1.1-4.4c5.4-18.6,20.5-36.3,48.3-45.4c0.8-0.2,1.6,0,2.1,0.5s0.8,1.4,0.5,2.1 C-197.3-434.6-215-419.6-233.6-414.2z M-174.7-393c-0.8,1.4-2.3,2.3-3.9,2.3s-3.1-0.9-3.9-2.3c-9.3-17-11.2-40.1,2-66.2 c0.4-0.7,1.1-1.1,1.9-1.1s1.5,0.4,1.9,1.1C-163.5-433.2-165.4-410-174.7-393z M-118.1-419.7c0.5,1.6,0,3.2-1.1,4.4 c-1.2,1.1-2.8,1.6-4.4,1.1c-18.6-5.4-36.3-20.5-45.4-48.3c-0.2-0.8-0.1-1.6,0.5-2.1c0.6-0.6,1.4-0.8,2.1-0.5 C-138.6-456-123.6-438.3-118.1-419.7z M-97-470.8c-17,9.3-40.2,11.2-66.2-2c-0.7-0.4-1.1-1.1-1.1-1.9s0.4-1.5,1.1-1.9 c26.1-13.2,49.2-11.4,66.2-2c1.4,0.8,2.3,2.3,2.3,3.9C-94.7-473-95.6-471.5-97-470.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-260.6-440.7c-1.2-2.6-3.9-4.4-7-4.4c-4.3,0-7.7,3.5-7.7,7.7c0,0.9,0.2,1.8,0.5,2.6c0.4,0.8,0.9,1.5,1.5,2.1 c3,3,7.9,3,10.9,0C-260.2-434.9-259.6-438-260.6-440.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-267.6-504.2c3.1,0,5.7-1.8,7-4.4c1-2.7,0.4-5.9-1.8-8c-3-3-7.9-3-10.9,0c-0.6,0.6-1.1,1.4-1.5,2.2 c-0.3,0.8-0.5,1.7-0.5,2.6C-275.3-507.7-271.8-504.2-267.6-504.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-212.6-556.7c2.6-1.2,4.4-3.9,4.4-7c0-4.3-3.4-7.7-7.7-7.7c-0.9,0-1.8,0.2-2.6,0.5c-0.8,0.4-1.5,0.9-2.1,1.5 c-3,3-3,7.9,0,10.9C-218.5-556.3-215.3-555.7-212.6-556.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-144.7-556.7c2.7,1,5.9,0.4,8-1.8c3-3,3-7.9,0-10.9c-0.6-0.6-1.4-1.2-2.1-1.5c-0.8-0.3-1.7-0.5-2.6-0.5 c-4.3,0-7.7,3.5-7.7,7.7C-149.1-560.5-147.3-557.9-144.7-556.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-96.7-508.6c1.2,2.6,3.9,4.4,7,4.4c4.3,0,7.7-3.5,7.7-7.7c0-0.9-0.2-1.8-0.4-2.6c-0.4-0.8-0.9-1.5-1.5-2.2 c-3-3-7.9-3-10.9,0C-97-514.5-97.6-511.3-96.7-508.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-89.7-445.1c-3.1,0-5.7,1.8-7,4.4c-1,2.7-0.4,5.9,1.8,8c3,3,7.9,3,10.9,0c0.6-0.6,1.2-1.4,1.5-2.1 c0.3-0.8,0.4-1.7,0.4-2.6C-82-441.7-85.4-445.1-89.7-445.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-144.7-392.7c-2.6,1.2-4.4,3.9-4.4,7c0,4.3,3.4,7.7,7.7,7.7c0.9,0,1.8-0.2,2.6-0.5c0.8-0.4,1.5-0.9,2.1-1.5 c3-3,3-7.9,0-10.9C-138.8-393-142-393.6-144.7-392.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-212.6-392.7c-2.7-1-5.9-0.4-8,1.8c-3,3-3,7.9,0,10.9c0.6,0.6,1.4,1.1,2.1,1.5c0.8,0.3,1.7,0.5,2.6,0.5 c4.3,0,7.7-3.5,7.7-7.7C-208.2-388.8-210-391.5-212.6-392.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-178.5,23.8c-0.9,0-1.8,0.4-2.3,1.3c-13.4,21.7-29.6,48.8-29.6,60c0,13.2,14.5,49,24.1,73.9 c-12.5-22.2-28.6-50.8-37.8-58.3c-8.5-6.9-39.1-11.5-63.9-14.8c-1-0.1-1.9,0.3-2.4,0.9c-0.5,0.7-0.8,1.6-0.5,2.6 c8.1,23.6,18.7,52.7,27.1,59.7c8.8,7.2,37.9,16.8,61.7,24.6c-18.6-4.2-40.9-9.1-49.1-9.1c-8.1,0.1-27.7,7.8-43.3,14.1 c-0.6,0.2-0.9,0.7-0.9,1.1s0.3,0.8,0.9,1.1c15.7,6.2,35.4,13.7,43.5,13.6c8.2-0.1,30.2-4.6,48.4-8.6c-10.3,3.6-22.1,8.2-31.4,11.3 c-3,1-11.3,11.3-17.4,20.3c-0.6,0.9,0.3,2.2,1.5,2c9.8-1.4,29.9-4.1,34.8-5.7c3.9-1.3,10.5-7.2,17.2-13.8 c-1.5,1.9-2.7,3.5-3.2,4.7c-2.4,5.2-3.3,16.4,0.6,22.4c8.1-3,16.7-12.2,19.1-17.4c1.6-3.4,2.3-12.3,2.8-20 c0.5,7.7,1.2,16.6,2.8,20c2.4,5.2,11,14.4,19.1,17.4c3.9-6.1,3-17.2,0.6-22.4c-0.5-1.1-1.7-2.8-3.2-4.7 c6.7,6.6,13.4,12.6,17.2,13.8c4.9,1.6,25,4.3,34.8,5.7c1.1,0.2,2.1-1.1,1.5-2c-6.1-8.9-14.4-19.2-17.4-20.3 c-9.3-3.1-21-7.7-31.4-11.3c18.2,4,40.2,8.5,48.4,8.6c8.1,0.1,27.8-7.4,43.5-13.6c0.6-0.2,0.9-0.7,0.9-1.1s-0.3-0.8-0.9-1.1 c-15.7-6.4-35.3-14.1-43.3-14.1c-8.2-0.1-30.5,4.8-49.1,9.1c23.8-7.8,52.8-17.3,61.7-24.6c8.5-6.9,19-36.1,27.1-59.7 c0.3-0.9,0.1-1.9-0.5-2.6c-0.6-0.7-1.4-1.1-2.4-0.9c-24.7,3.3-55.4,7.9-63.9,14.8c-9.2,7.5-25.2,36.1-37.8,58.3 c9.6-24.9,24.1-60.6,24.1-73.9c0-11.2-16.2-38.3-29.6-60C-176.7,24.2-177.6,23.8-178.5,23.8z M-178.5,180.6 c-5.8-31.6-28.1-108.7,0-108.7S-172.7,149-178.5,180.6z M-260.2,112.6c18.2-24.1,64.8,42.6,81.4,68 C-221.1,163.3-275.1,132.2-260.2,112.6z M-178.1,180.6c16.6-25.4,63.1-92.2,81.4-68C-81.9,132.2-135.9,163.3-178.1,180.6z  M-194.8,183.2c-30,3.8-66.2,8-66.2-3.5c0-17.3,49-5.7,75.2,0.9c1.6,0.4,2.8,0.7,3.7,0.9C-186.1,182.1-190.6,182.7-194.8,183.2z  M-174.9,181.7c0.9-0.2,2.1-0.5,3.7-0.9C-145,174-96,162.5-96,179.8c0,11.5-36.1,7.3-66.2,3.5 C-166.4,182.7-170.9,182.1-174.9,181.7z M-227.8,206.6c-12.8-4.9,27.7-20.6,46.9-24.3C-182,184.2-216.7,210.8-227.8,206.6z  M-176.2,182.2c19.2,3.8,59.8,19.4,46.9,24.3C-140.3,210.8-175,184.2-176.2,182.2z M-193.8,213c-7.6,0.8,4.6-20.7,14.2-30.8 C-180,189.9-181.8,211.8-193.8,213z M-177.4,182.2c9.6,10.1,21.8,31.6,14.2,30.8C-175.2,211.8-177,189.9-177.4,182.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-212.8,70.3c-3.9,8-5.4,13.5-6.1,22.3c-8-3.9-13.5-5.4-22.3-6.1c3.9-8,5.4-13.5,6.1-22.3 C-227.1,68.1-221.6,69.6-212.8,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-144.2,70.3c3.9,8,5.4,13.5,6.1,22.3c8-3.9,13.5-5.4,22.3-6.1c-3.9-8-5.4-13.5-6.1-22.3 C-129.9,68.1-135.4,69.6-144.2,70.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-262.4,155.4c-5.7,3.8-8.8,6.9-12.6,12.6c-3.8-5.7-6.9-8.8-12.6-12.6c5.7-3.8,8.8-6.9,12.6-12.6 C-271.2,148.4-268,151.5-262.4,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-94.6,155.4c5.7,3.8,8.8,6.9,12.6,12.6c3.8-5.7,6.9-8.8,12.6-12.6c-5.7-3.8-8.8-6.9-12.6-12.6 C-85.8,148.4-88.9,151.5-94.6,155.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-251.6,201.1c-2.2,4.3-3.1,7.2-3.5,12c-4.3-2.2-7.2-3.1-12-3.5c2.2-4.3,3.1-7.2,3.5-12 C-259.3,199.8-256.4,200.6-251.6,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-105.4,201.1c2.2,4.3,3.1,7.2,3.5,12c4.3-2.2,7.2-3.1,12-3.5c-2.2-4.3-3.1-7.2-3.5-12 C-97.7,199.8-100.6,200.6-105.4,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-206.8,223.2c-2.8,0.1-4.5,0.6-7,1.7c-0.1-2.8-0.6-4.5-1.7-7c2.8-0.1,4.5-0.6,7-1.7 C-208.4,218.9-207.9,220.7-206.8,223.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-150.2,223.2c2.8,0.1,4.5,0.6,7,1.7c0.1-2.8,0.6-4.5,1.7-7c-2.8-0.1-4.5-0.6-7-1.7 C-148.6,218.9-149.1,220.7-150.2,223.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4-582.9c-13.8,18-32.6,37.4-39.1,57.7c-0.9,2.7-1.5,5.5-1.7,8.5c-3,37.2,24,46.3,28.4,86.1c0,0,0,0,0,0 c2.7,1.8,9,2,12.5,2c3.4,0,9.8-0.2,12.5-2c0,0,0,0,0,0c4.4-39.8,31.3-48.9,28.4-86.1c-0.2-2.9-0.8-5.7-1.7-8.5 C453-545.5,434.2-564.8,420.4-582.9z M420.4-580.6c-0.1-0.3-0.1-0.6,0-0.9C420.5-581.2,420.5-580.9,420.4-580.6z M420.4-432.5 c-5.6,0.1-7.5-1.1-8.8-14.4c-2.2-23.6-15.7-36.3-15.7-58.8c0-14.3,15.1-29.1,24.4-39.6c9.3,10.5,24.4,25.3,24.4,39.6 c0,22.5-13.4,35.2-15.7,58.8C427.9-433.5,426-432.4,420.4-432.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.5-516.8c0.2-2.9,0.8-5.7,1.7-8.5c-11.9-13-39.5-39-76.8-24.9c52.1,21.2,34.1,95.7,97.1,117.5 c2,0.7,4.1,1.4,6.4,1.9c0,0,0,0,0,0C403.6-470.5,376.6-479.5,379.5-516.8z M339.4-526.8c3.5,0.9,6.8,2.2,9.8,3.6 c11.7,5.4,20.5,15.5,24.4,27.8c7.7,24.4,24.2,40.1,29.6,59.9C355.6-455.7,355.6-510.6,339.4-526.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.2-516.8c-0.2-2.9-0.8-5.7-1.7-8.5c11.9-13,39.5-39,76.8-24.9c-52.1,21.2-34.1,95.7-97.1,117.5 c-2,0.7-4.1,1.4-6.4,1.9c0,0,0,0,0,0C437.2-470.5,464.2-479.5,461.2-516.8z M501.3-526.8c-3.5,0.9-6.8,2.2-9.8,3.6 c-11.7,5.4-20.5,15.5-24.4,27.8c-7.7,24.4-24.2,40.1-29.6,59.9C485.1-455.7,485.1-510.6,501.3-526.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4-428.7c-3.4,0-9.8-0.2-12.5-2c0,0,0,0,0,0l0,0c-7.5,12.5-26.2,19.5-23.9,33.3c0.6,3.6,3.4,6.6,7.1,9.4 c9.5,7.1,20.5,14,29.3,21.2c8.8-7.3,19.7-14.1,29.3-21.2c3.7-2.8,6.5-5.8,7.1-9.4c2.3-13.9-16.4-20.9-23.9-33.3l0,0c0,0,0,0,0,0 C430.1-428.9,423.8-428.7,420.4-428.7z M420.4-383.1c-2.8-2.5-10.8-7.5-17.5-13.3c-2-1.8-3.5-4-3.8-6.6c-0.3-2.6,0.7-5,2.4-7.1 c4-4.9,8-9.4,10.3-12.3c1.5-1.8,3.2-3.1,5.5-2.9h6.2c2.3-0.2,4.1,1.1,5.5,2.9c2.3,2.9,6.3,7.4,10.3,12.3c1.7,2.1,2.7,4.4,2.4,7.1 c-0.3,2.6-1.8,4.9-3.8,6.6C431.2-390.6,423.1-385.7,420.4-383.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M401.5-432.6c-34.6,2.1-49.1,45.4-78.2,37.8c16.3,14.9,50.1,24.1,67.8,6.9c-3.7-2.8-6.5-5.8-7.1-9.4 c-2.3-13.9,16.4-20.9,23.9-33.3C405.7-431.2,403.6-431.9,401.5-432.6z M387.5-417.8c-4.6,4.2-6.4,8.8-8.4,15.4 c-2,6.5-6.2,10.5-13.2,11.4c-7.6,1-13.6-0.4-18.2-3.4c18.5-8.1,27.3-30.1,54-35.7C400.4-427.4,394.1-423.9,387.5-417.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M439.2-432.6c34.6,2.1,49.1,45.4,78.2,37.8c-16.3,14.9-50.1,24.1-67.8,6.9c3.7-2.8,6.5-5.8,7.1-9.4 c2.3-13.9-16.4-20.9-23.9-33.3C435-431.2,437.2-431.9,439.2-432.6z M453.3-417.8c4.6,4.2,6.4,8.8,8.4,15.4 c2,6.5,6.2,10.5,13.2,11.4c7.6,1,13.6-0.4,18.2-3.4c-18.5-8.1-27.3-30.1-54-35.7C440.3-427.4,446.7-423.9,453.3-417.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M379.7-557.3c2.1,9.1,1.8,17-0.7,17.6s-6.4-6.3-8.5-15.4s-1.8-17,0.7-17.6S377.5-566.4,379.7-557.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461-557.3c-2.1,9.1-1.8,17,0.7,17.6s6.4-6.3,8.5-15.4s1.8-17-0.7-17.6S463.2-566.4,461-557.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-175.8,509.3c4.9,0,15.9-3.6,16.4-23.9c0,0-6.5,2-16.4,2s-16.4-2-16.4-2 C-191.6,505.6-180.6,509.3-175.8,509.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-192.7,459.8c-16.8-40.1-37.3-76.4-106.4-63.1c31.8,11.7,68.1,86.1,123.4,86.1s91.7-74.4,123.4-86.1 c-69.1-13.3-89.6,23-106.4,63.1c22.9-62.5,4.2-87.2-17-118.1C-196.9,372.6-215.6,397.3-192.7,459.8z M-155.4,471.7 c13.6-31.3,30.5-59.8,73.1-61.5C-102.8,430.6-126.3,459.8-155.4,471.7z M-269.2,410.2c42.6,1.7,59.5,30.2,73.1,61.5 C-225.2,459.8-248.7,430.6-269.2,410.2z M-175.8,372c30.7,31.9,11.5,76.6,0,97.6C-187.2,448.6-206.4,403.9-175.8,372z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-504.5-390.1c-9.2,22.8-74.6,7.1-90.4-13.1c-7.6-9.7,1.6-29.3,15.6-43.6c2.7,5.8,10.3,13.3,13.7,17.8 c-1.8,1.2-4.1,8.7-2.7,13.1c4.3,13.7,41.4,24.1,43.3,9.8c1.8-14,5.5-23.5,15.2-24.9c3,0.5,5.8,1.4,8.4,2.7 c-3.2,3.1-5.8,6.9-6.5,11.8C-509.9-404-500.2-400.7-504.5-390.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-451.4-390.1c9.2,22.8,74.6,7.1,90.4-13.1c7.6-9.7-1.6-29.3-15.6-43.6c-2.7,5.8-10.3,13.3-13.7,17.8 c1.8,1.2,4.1,8.7,2.7,13.1c-4.3,13.7-41.4,24.1-43.3,9.8c-1.8-14-5.5-23.5-15.2-24.9c-3,0.5-5.8,1.4-8.4,2.7 c3.2,3.1,5.8,6.9,6.5,11.8C-446-404-455.6-400.7-451.4-390.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-477.9-546.8c-10.8,0-26.9,16-30.1,30.7c-7.2-3.1-15.3-5.5-23.4-7.1c7.4-32.5,41.5-54.7,53.3-54.7h0.4 c11.8,0,46,22.3,53.3,54.7c-8.1,1.6-16.2,4-23.4,7.1C-451-530.8-467.2-546.8-477.9-546.8L-477.9-546.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-478.2-430.6c-3,0-5.4-0.4-7.5-1c-1.6-0.5-3-1-4.2-1.7c-1.6-0.9-3-1.9-4.2-2.8c-0.3-0.3-0.6-0.5-0.9-0.8 c-2.2-6.3-0.7-11.4,2.7-15c3.5-3.6,8.8-5.7,14.2-5.8h0.5c5.4,0.1,10.8,2.1,14.2,5.8c3.4,3.6,4.9,8.7,2.7,15 c-0.3,0.2-0.6,0.5-0.9,0.8c-1.2,1-2.6,2-4.2,2.8c-1.2,0.7-2.6,1.3-4.2,1.7c-2.1,0.6-4.6,1-7.5,1H-478.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-478.1-437.2c-1.5,0-2.8-0.2-3.8-0.5c-0.8-0.2-1.5-0.5-2.2-0.8c-0.8-0.4-1.5-0.9-2.2-1.4 c-0.1-0.1-0.3-0.2-0.5-0.4c-1.1-3-0.3-5.5,1.4-7.2c1.8-1.8,4.5-2.7,7.2-2.8h0.3c2.7,0,5.5,1,7.2,2.8c1.7,1.7,2.5,4.2,1.4,7.2 c-0.1,0.1-0.3,0.2-0.5,0.4c-0.6,0.5-1.3,1-2.2,1.4c-0.6,0.3-1.3,0.6-2.2,0.8c-1.1,0.3-2.3,0.5-3.8,0.5H-478.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-501-428.7c-0.1,0.1-0.3,0.2-0.5,0.4c0.2,0.1,0.3,0.2,0.5,0.2C-500.9-428.3-500.9-428.5-501-428.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-454.9-428.7c0.1,0.1,0.3,0.2,0.5,0.4c-0.2,0.1-0.3,0.2-0.5,0.2C-455-428.3-454.9-428.5-454.9-428.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-492.4-459.7c1.5-15.5,13.6-16.2,11.9-30.4c-1.3-10.8-12.7-19.9-27.6-26.1c-7.2-3.1-15.3-5.5-23.4-7.1 c-22.3-4.5-45.3-3.3-53.6,5.9c-10.6,11.7-6,45.2,5.8,70.6c2.7,5.8,5.8,11.2,9.2,15.8c6.7,8.9,14.4,14.8,22.6,15 c14.3,0.3,13.8-11.8,29-14.8c3-0.6,5.9-0.6,8.7-0.1c3,0.5,5.8,1.4,8.4,2.7c0.2-0.2,0.4-0.4,0.6-0.5c-0.1-1.9-0.2-3.5-0.2-4.9 c0,0,0,0,0,0c0-3.4,0.6-5.5,1.9-5.5c0.2,0,0.4,0,0.6,0c2.8,0.2,4.6,1.9,6.9,3.7c-1.8-4.9-0.5-9,2.2-11.8 C-491.4-451.3-492.7-455.6-492.4-459.7z M-504.3-445.1c-4.5-1-9.6,0.1-14.9,1.8c-9,2.9-18.4,7.7-26,7c-3.6-0.3-8-4.5-11.9-10.6 c-2.3-3.6-4.4-7.8-6.2-12.3c-5.3-13.5-7.2-29.5,0.2-37.7c7.4-8.3,23.5-8.3,37.6-4.8c12.8,3.2,23.9,9.4,25.1,15.1 c1.9,9-3.9,21.6-4.9,32.3C-505.4-451.1-505.2-447.9-504.3-445.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-463.5-459.7c-1.5-15.5-13.6-16.2-11.9-30.4c1.3-10.8,12.7-19.9,27.6-26.1c7.2-3.1,15.3-5.5,23.4-7.1 c22.3-4.5,45.3-3.3,53.6,5.9c10.6,11.7,6,45.2-5.8,70.6c-2.7,5.8-5.8,11.2-9.2,15.8c-6.6,8.9-14.4,14.8-22.6,15 c-14.3,0.3-13.8-11.8-29-14.8c-3-0.6-5.9-0.6-8.7-0.1c-3,0.5-5.8,1.4-8.4,2.7c-0.2-0.2-0.4-0.4-0.6-0.5c0.1-1.9,0.2-3.5,0.2-4.9 c0,0,0,0,0,0c0-3.4-0.6-5.5-1.9-5.5c-0.2,0-0.4,0-0.6,0c-2.8,0.2-4.6,1.9-6.9,3.7c1.8-4.9,0.5-9-2.2-11.8 C-464.4-451.3-463.1-455.6-463.5-459.7z M-451.6-445.1c4.5-1,9.6,0.1,14.9,1.8c9,2.9,18.4,7.7,26,7c3.6-0.3,8-4.5,11.9-10.6 c2.3-3.6,4.4-7.8,6.2-12.3c5.3-13.5,7.2-29.5-0.2-37.7c-7.4-8.3-23.5-8.3-37.6-4.8c-12.8,3.2-23.9,9.4-25.1,15.1 c-1.9,9,3.9,21.6,4.9,32.3C-450.5-451.1-450.6-447.9-451.6-445.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-478.1-371.6c-10.2,0-20.7-37.1-22.6-56.4c0-0.3-0.1-0.6-0.1-0.8c-0.1-1.9-0.2-3.5-0.2-4.9c0,0,0,0,0,0 c0-3.4,0.6-5.5,1.9-5.5c0.2,0,0.4,0,0.6,0c2.8,0.2,4.6,1.9,6.9,3.7c0.2,0.2,0.5,0.4,0.7,0.6c1,0.8,2.1,1.5,3.4,2.2 c-0.2,0.5-0.5,1.1-0.6,1.7c-0.5,1.7-0.8,3.7-0.8,5.9c0,1.3,0,2.6,0.1,4c0.1,2,0.4,4.2,0.8,6.3c0,0,0,0,0,0 c2.1,11.4,7.1,22.9,10.2,22.1h0c3.1,0.8,8.1-10.6,10.2-22.1c0,0,0,0,0,0c0.4-2.1,0.6-4.3,0.8-6.3c0.1-1.4,0.1-2.7,0.1-4 c-0.1-2.2-0.3-4.2-0.8-5.9c-0.2-0.6-0.4-1.2-0.6-1.7c1.3-0.7,2.4-1.5,3.4-2.2c0.2-0.2,0.5-0.4,0.7-0.6c2.2-1.8,4-3.4,6.9-3.7 c0.2,0,0.4,0,0.6,0c1.2,0,1.8,2.1,1.9,5.5c0,0,0,0,0,0c0,1.4-0.1,3.1-0.2,4.9c0,0.3-0.1,0.5-0.1,0.8 c-1.9,19.2-12.4,56.4-22.6,56.4H-478.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-548,-483.4 -504.3,-438.9 -498.6,-447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-407.8,-483.4 -451.6,-438.9 -457.2,-447  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "-477.9,-543.4 -481.1,-455.9 -474.7,-455.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.6,517.5c3.1,5.3,39.2,18.5,60.3,14.9c13.6-2.3,31.1-14.3,46.8-41.7c3.7,4.5,6.9,8,7.6,9.4 c0.7-1.4,4.2-5.2,8.1-10.1c15.8,27.9,33.5,40,47.2,42.4c21.1,3.6,57.2-9.5,60.3-14.9c3.1-5.3-3.6-43.2-17.3-59.6 c-8.9-10.7-28.1-19.9-60-19.7c2.6-6.5,4.3-12.3,5.3-13.7c-1.5,0.1-6.1-0.9-11.9-1.9c15.1-26.5,16.5-47.1,11.8-59.8 c-7.4-20.1-36.8-44.8-43-44.8c-6.2,0-35.6,24.7-43,44.8c-4.7,12.7-3.3,33.2,11.7,59.6c-6.2,1-11.2,2.1-12.8,2 c1,1.4,2.7,7.1,5.3,13.6c-31.3,0-50.2,9.1-59,19.7C12.2,474.3,5.5,512.1,8.6,517.5z M123.2,445.1l-27.1-11.4 c6.5-1.8,24-4.3,27.1,7.4c3.1-11.7,20.6-9.2,27.1-7.4L123.2,445.1z M141.1,421.3c-7.6,0-14.8,1.6-17.9,7.1c-3-5.3-9.6-7-16.9-7.1 c-14.7-33.4,2.7-50.1,17.4-59.5C138.3,371.2,155.8,388,141.1,421.3z M139,479c3.7-6.5,5.8-13.4,2.6-18.8 c5.6,0.1,10.1-4.2,13.8-9.8c38.7,3,44.8,27.3,45.5,45c-15.8,8.2-39.7,15-61.6-16.7C139.2,479,139.1,479,139,479z M123.5,481.1 l3.7-29.2l23.5-17.8c-1.7,6.6-8.3,22.9-20,19.8C139.2,462.5,128.3,476.4,123.5,481.1z M115.8,453.9c-11.7,3.2-18.3-13.2-20-19.8 l23.5,17.8l3.7,29.2C118.1,476.4,107.2,462.5,115.8,453.9z M46.5,495.6c0.8-17.6,6.8-41.7,44.6-45c3.6,5.6,8.1,9.8,13.7,9.7 c-3.2,5.5-1,12.5,2.9,19.2C85.9,510.5,62.1,503.7,46.5,495.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.8784 -0.478 0.478 0.8784 -175.2686 137.9524)",
    className: "st1",
    cx: 183.4,
    cy: 413.4,
    rx: 11.8,
    ry: 11.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 63.7,
    cy: 413.3,
    rx: 11.8,
    ry: 11.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9735 -0.2286 0.2286 0.9735 -115.126 41.8475)",
    className: "st1",
    cx: 123.1,
    cy: 517.9,
    rx: 11.8,
    ry: 11.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M460.9-244.9c-0.3-3.4-1-6.5-2-9.1c-6.6-18-33-40.2-38.6-40.2s-31.9,22.2-38.6,40.1c-1,2.7-1.7,5.7-2,9.1 c-3.1-1.4-6.1-2.4-8.9-2.9c-18.9-3.2-51.3,8.5-54.1,13.3c-2.8,4.8,3.2,38.7,15.5,53.5c1.8,2.2,4.1,4.3,6.9,6.3 c-2.8,2-5.1,4.1-6.9,6.3c-12.3,14.8-18.2,48.7-15.5,53.5c2.8,4.8,35.1,16.6,54.1,13.3c2.8-0.5,5.8-1.4,8.9-2.9 c0.3,3.4,1,6.5,2,9.1c6.6,18,33,40.2,38.6,40.2s31.9-22.2,38.6-40.2c1-2.7,1.7-5.7,2-9.1c3.1,1.4,6.1,2.4,8.9,2.9 c18.9,3.2,51.3-8.5,54.1-13.3s-3.2-38.7-15.5-53.5c-1.8-2.2-4.1-4.3-6.9-6.3c2.8-2,5.1-4.1,6.9-6.3c12.3-14.8,18.2-48.7,15.5-53.5 c-2.8-4.8-35.1-16.6-54.1-13.3C467-247.3,464.1-246.4,460.9-244.9z M404.6-202.1c-12.9-29.6,2.7-44.6,15.8-52.9 c13.1,8.3,28.7,23.3,15.8,52.9c19.2-26,40-19.9,53.7-12.8c-0.7,15.5-5.8,36.5-38,40.1c32.1,3.7,37.3,24.6,38,40.1 c-13.8,7.2-34.5,13.2-53.7-12.8c12.9,29.7-2.7,44.6-15.8,52.9c-13.1-8.3-28.7-23.3-15.8-52.9c-19.2,26-40,19.9-53.7,12.8 c0.7-15.5,5.8-36.5,38-40.1c-32.1-3.7-37.3-24.6-38-40.1C364.6-222,385.4-228,404.6-202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436-201.6c-5.1-9.6-14.5-18.6-15.6-21c-1.1,2.4-10.4,11.4-15.6,21c-10.8-0.3-23.4,3.2-26,3 c1.5,2.1,4.7,14.8,10.4,24c-5.7,9.2-8.9,21.8-10.4,24c2.6-0.2,15.1,3.3,26,3c5.1,9.6,14.5,18.6,15.6,21c1.1-2.3,10.4-11.4,15.6-21 c10.8,0.3,23.4-3.2,26-3c-1.5-2.1-4.7-14.8-10.4-24c5.7-9.2,8.9-21.8,10.4-24C459.3-198.4,446.8-202,436-201.6z M411.1-190.8 c1.8-6,6.7-11.7,9.3-14.2c2.6,2.5,7.5,8.2,9.3,14.2c6.1-1.4,13.5-0.1,17,0.9c-0.9,3.5-3.4,10.6-7.7,15.1 c4.3,4.6,6.8,11.6,7.7,15.1c-3.5,1-10.9,2.4-17,0.9c-1.8,6-6.7,11.7-9.3,14.2c-2.6-2.5-7.5-8.2-9.3-14.2c-6.1,1.4-13.5,0.1-17-0.9 c0.9-3.5,3.4-10.6,7.7-15.1c-4.3-4.6-6.8-11.6-7.7-15.1C397.6-190.9,405-192.2,411.1-190.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.7-271.2L364.7-271.2c12.6-5.5,14,15.4,12.3,21.3C371-251.4,353.6-263.1,364.7-271.2L364.7-271.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M531.8-174.7L531.8-174.7c-1.5,13.6-20.3,4.4-24.6,0C511.5-179.1,530.4-188.4,531.8-174.7L531.8-174.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M364.7-78.2L364.7-78.2c-11.1-8.1,6.4-19.8,12.3-21.3C378.6-93.6,377.2-72.6,364.7-78.2L364.7-78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4-177.6L420.4-177.6c-5.7-2.2-1.2-29.2,0.8-35.2C422.9-206.7,426.2-179.6,420.4-177.6L420.4-177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.9-173.3L417.9-173.3c0.9,6-24.7,15.6-30.9,16.9C391.5-160.9,413.3-177.3,417.9-173.3L417.9-173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.9-173.2L422.9-173.2c4.8-3.8,25.8,13.6,30.1,18.3C446.8-156.5,421.7-167.2,422.9-173.2L422.9-173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M422.9-176.2L422.9-176.2c4.8,3.8,25.8-13.6,30.1-18.3C446.8-192.9,421.7-182.1,422.9-176.2L422.9-176.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.9-176.1L417.9-176.1c0.9-6-24.7-15.6-30.9-16.9C391.5-188.5,413.3-172.1,417.9-176.1L417.9-176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4-171.8L420.4-171.8c-5.7,2.2-1.2,29.2,0.8,35.2C422.9-142.7,426.2-169.9,420.4-171.8L420.4-171.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M463.9-250c-1.6-6.1-0.1-26.6,12.3-21.2C487-263.2,470-251.7,463.9-250z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M463.9-99.4c6,1.7,23.1,13.2,12.3,21.2C463.8-72.8,462.3-93.3,463.9-99.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M333.4-174.7c-4.5,4.4-23,13.4-24.5,0C310.4-188.1,328.9-179.1,333.4-174.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.3-237.2c-21.1,6.3-29.5,50.7-47.1,50.2c-5.9-16.6,33.8-38.3,33.2-60.3c-0.5-20.8-32.2-41.9-44.5-49.5 c-12.3,7.7-44,28.7-44.5,49.5c-0.6,22,39.1,43.7,33.2,60.3c-17.6,0.5-26-43.9-47.1-50.2c-20-5.9-49.8,17.6-60.9,27 C5.2-196,15.4-159.5,35-152.5c20.8,7.3,53.7-23.7,67.6-12.9c-5,16.9-49.8,11.1-62.3,29.3C28.5-119,41.8-83.4,47.2-70 c14.5,1.1,52.5,2.6,65.1-13.9c13.4-17.5-5.9-58.4,8.6-68.3c14.5,9.9-4.8,50.8,8.6,68.3c12.7,16.5,50.6,15,65.1,13.9 c5.5-13.5,18.7-49.1,6.9-66.2c-12.5-18.1-57.3-12.4-62.3-29.3c13.9-10.7,46.8,20.3,67.6,12.9c19.6-6.9,29.9-43.5,33.4-57.6 C229.1-219.6,199.3-243.1,179.3-237.2z M76.8-172.9c-14.1,3.5-27.5,5.8-33.5,3.9c-12.2-4-14.4-24.6-15.4-32.7 c5.6-5.9,19.5-21.3,31.7-17.4c6,2,15.5,11.8,24.9,22.9c7,8.3,12.7,16.4,12.5,17C96.7-178.7,87.3-175.4,76.8-172.9z M108.7-213.9 c-7.6-12.3-14.1-24.4-14.1-30.7c0-12.8,19-21.3,26.3-24.8c7.3,3.5,26.3,12,26.3,24.8c0,6.3-6.4,18.4-14.1,30.7 c-5.7,9.2-11.7,17.1-12.3,17.1C120.4-196.7,114.4-204.7,108.7-213.9z M105.9-129.9c-1.1,14.5-3,28-6.7,33.1 c-7.5,10.4-27.9,6.1-35.8,4.6c-3.9-7.1-14.3-25.1-6.7-35.5c3.7-5.1,16-11.1,29.4-16.6c10-4.1,19.6-7,20-6.6 C106.5-150.6,106.7-140.6,105.9-129.9z M130.6-158.1c-2.8-2.6-7.4-5.9-9.5-6.4c-0.1,0-0.1,0-0.2,0.1c-0.1,0-0.2-0.1-0.2-0.1 c-2,0.5-6.7,3.8-9.5,6.4c1.7-3.4,3.3-8.9,3.2-11c0-0.1-0.1-0.1-0.1-0.2c0-0.1,0-0.2,0-0.2c-1.1-1.8-5.7-5.2-9-7 c3.8,0.5,9.4,0.4,11.4-0.4c0.1-0.1,0.1-0.1,0.1-0.2c0.1,0,0.2-0.1,0.2-0.1c1.3-1.6,3.2-7,3.9-10.7c0.7,3.7,2.6,9.1,3.9,10.7 c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c2,0.8,7.6,0.9,11.4,0.4c-3.4,1.8-7.9,5.2-9,7c0,0.1,0,0.1,0,0.2 c-0.1,0.1-0.1,0.1-0.1,0.2C127.3-167,129-161.5,130.6-158.1z M155.8-144.3c13.4,5.5,25.7,11.5,29.4,16.6 c7.5,10.4-2.8,28.4-6.7,35.5c-8,1.5-28.3,5.8-35.8-4.6c-3.7-5.1-5.6-18.7-6.7-33.1c-0.8-10.8-0.6-20.8-0.1-21.1 C136.3-151.3,145.8-148.4,155.8-144.3z M198.6-169c-6,1.9-19.5-0.4-33.6-3.9c-10.5-2.6-19.9-5.9-20.1-6.4s5.5-8.7,12.5-17 c9.4-11.1,18.9-20.9,24.9-22.9c12.2-4,26.1,11.5,31.7,17.4C213-193.6,210.8-172.9,198.6-169z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.7-235c-2.8-9.6,1.4-32.9-23.6-32.5C43-243.8,66.4-240.6,74.7-235z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.1-235c8.3-5.6,31.8-8.8,23.6-32.5C165.7-268,169.9-244.7,167.1-235z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.7-147.1c7.9,6.2,18.2,27.5,38.2,12.4C226.6-158.7,205.7-147.5,195.7-147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.9-92.8c-3.4,9.4-20.5,25.8,0,40.2C141.5-67,124.4-83.4,120.9-92.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.2-147.1c-10-0.4-30.9-11.6-38.2,12.4C28-119.6,38.3-140.9,46.2-147.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M125.8-171.4c0,2.5-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6S125.8-173.9,125.8-171.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,105.7c-0.1,0.1-0.2,0.2-0.3,0.2c-3.5-5.2-7.5-1.7-4.9,5.8c2,5.8,3.1,6.4,5.2,12.2 c2.1-5.8,3.2-6.4,5.2-12.2c2.6-7.5-1.4-11-4.9-5.8C420.6,105.8,420.5,105.8,420.4,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M440.5,115.4c-0.1,0-0.3-0.1-0.4-0.1c1.9-5.9-3.3-6.9-7.6-0.2c-3.3,5.2-3.1,6.4-6.3,11.7 c5.8-1.9,7-1.5,12.8-3.5c7.5-2.7,7.7-8,1.5-7.4C440.5,115.6,440.5,115.5,440.5,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.5,137.1c-0.1-0.1-0.1-0.2-0.2-0.4c5.8-2.2,3.4-6.9-4.5-6.1c-6.1,0.7-7,1.6-13,2.4 c5.1,3.3,5.5,4.6,10.7,7.8c6.7,4.2,11,1,6.7-3.5C445.2,137.3,445.4,137.2,445.5,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.5,154.6c0.1-0.1,0.1-0.2,0.2-0.4c5.4,3.2,7.5-1.7,1.9-7.3c-4.3-4.4-5.6-4.4-10-8.7 c0.6,6.1-0.1,7.1,0.6,13.2c0.9,7.9,6.1,9.3,6.9,3.1C431.3,154.5,431.4,154.6,431.5,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M409.2,154.6c0.1,0,0.3-0.1,0.4-0.1c0.9,6.2,6,4.8,6.9-3.1c0.7-6.1,0-7.1,0.6-13.2c-4.4,4.3-5.7,4.4-10,8.7 c-5.6,5.6-3.5,10.5,1.9,7.3C409.1,154.4,409.1,154.5,409.2,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M395.3,137.1c0.1,0.1,0.2,0.2,0.3,0.2c-4.3,4.5,0,7.7,6.7,3.5c5.2-3.2,5.6-4.5,10.7-7.8 c-6.1-0.8-6.9-1.7-13-2.4c-7.9-0.9-10.4,3.9-4.5,6.1C395.4,136.9,395.3,137,395.3,137.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M400.2,115.4c0,0.1,0,0.3,0,0.4c-6.2-0.5-6,4.8,1.5,7.4c5.8,2,7,1.6,12.8,3.5c-3.2-5.2-3-6.5-6.3-11.7 c-4.2-6.7-9.5-5.7-7.6,0.2C400.5,115.3,400.4,115.3,400.2,115.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,11.8c0,0-16.5,7.9-27,15.1c-13.7,9.5-11.6,23.2-5.5,36.8c-6.9-13.2-16.3-23.5-32.3-18.6 c-12.2,3.7-28.6,11.7-28.6,11.7s-4.1,17.8-5,30.5c-1.2,16.6,10.9,23.5,25.4,27.3c-14.7-2.9-28.5-1.9-34.7,13.6 c-4.7,11.8-8.7,29.7-8.7,29.7s11.3,14.4,20.7,23c12.3,11.3,25.2,6.1,37.2-2.8c-11.4,9.7-19.2,21.1-11,35.6 c6.3,11.1,17.8,25.3,17.8,25.3s18.3,0.1,30.9-1.9c16.5-2.6,20.5-15.9,21-30.8c0.5,14.9,4.5,28.2,21,30.8c12.6,2,30.9,1.9,30.9,1.9 s11.5-14.2,17.8-25.3c8.3-14.5,0.4-25.9-11-35.6c12,8.9,24.9,14.1,37.2,2.8c9.4-8.6,20.7-23,20.7-23s-4-17.8-8.7-29.7 c-6.2-15.5-20-16.5-34.7-13.6c14.5-3.8,26.5-10.7,25.3-27.3c-0.9-12.7-5-30.5-5-30.5s-16.4-8-28.6-11.7 c-16-4.8-25.4,5.4-32.3,18.6c6-13.6,8.2-27.4-5.5-36.8C436.9,19.6,420.4,11.8,420.4,11.8z M410.4,110.7 c9.5-12.9-7.9-21.6-9.8-37.9c-1.6-14,8.1-18.9,19.7-26.4c11.6,7.4,21.3,12.4,19.7,26.4c-1.9,16.3-19.3,25-9.8,37.9 c16-0.6,12-19.6,23.5-31.2c9.9-9.9,19.9-5.5,32.9-1c1.4,13.7,3.6,24.4-8.3,31.8c-13.9,8.7-31.6,0.5-35.7,16 c10.4,12.1,22.8-2.9,39.1-1.1c14,1.5,16.6,12.1,21.3,25.1c-9.8,9.7-16.8,18-30.1,13.4c-15.5-5.4-20.1-24.4-34.8-17.9 c-3,15.7,16.5,16,25.2,29.9c7.5,11.9,0.9,20.6-6.3,32.3c-13.7-1.7-24.6-1.9-29.2-15.2c-5.4-15.5,6.5-30.9-7.6-38.4 c-14.1,7.5-2.2,22.9-7.6,38.4c-4.6,13.3-15.5,13.5-29.2,15.2c-7.2-11.7-13.8-20.4-6.3-32.3c8.8-13.9,28.2-14.2,25.2-29.9 c-14.6-6.4-19.3,12.5-34.8,17.9c-13.2,4.7-20.2-3.7-30.1-13.4c4.7-13,7.4-23.6,21.3-25.1c16.3-1.8,28.7,13.2,39.1,1.1 c-4.1-15.4-21.8-7.3-35.7-16c-11.9-7.4-9.7-18.1-8.3-31.8c13.1-4.4,23-8.9,32.9,1C398.5,91,394.4,110.1,410.4,110.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M373.8,34.6c0.8-0.4,1.6-0.6,2.5-0.6c3.1,0,5.7,2.5,5.7,5.7c0,2.3-1.4,4.3-3.3,5.2c-1.9,1-4.3,0.8-6.1-0.6 c-2.5-2-2.9-5.5-0.9-8C372.3,35.5,373,34.9,373.8,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467,34.6c0.8,0.4,1.5,0.9,2,1.6c2,2.5,1.5,6-0.9,8c-1.8,1.4-4.2,1.6-6.1,0.6c-2-0.9-3.3-2.9-3.3-5.2 c0-3.1,2.5-5.7,5.7-5.7C465.3,34,466.2,34.2,467,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M525.1,107.4c0.2,0.8,0.2,1.7,0,2.6c-0.7,3.1-3.7,5-6.8,4.3c-2.2-0.5-3.8-2.3-4.3-4.4c-0.5-2.1,0.2-4.4,2-5.8 c2.5-2,6-1.6,8,0.9C524.5,105.8,524.9,106.6,525.1,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M504.3,198.3c-0.5,0.7-1.2,1.2-2,1.6c-2.8,1.4-6.2,0.2-7.6-2.6c-1-2.1-0.6-4.4,0.7-6.1 c1.3-1.7,3.5-2.6,5.8-2.1c3.1,0.7,5,3.7,4.3,6.8C505.3,196.8,504.9,197.6,504.3,198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M420.4,238.7c-0.9,0-1.7-0.2-2.5-0.6c-2.8-1.4-4-4.8-2.6-7.6c1-2.1,3.1-3.2,5.2-3.2c2.1,0,4.2,1.2,5.2,3.2 c1.4,2.8,0.2,6.2-2.6,7.6C422.1,238.6,421.2,238.7,420.4,238.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.4,198.3c-0.5-0.7-1-1.5-1.1-2.4c-0.7-3.1,1.2-6.1,4.3-6.8c2.2-0.5,4.5,0.4,5.8,2.1 c1.4,1.7,1.7,4,0.7,6.1c-1.4,2.8-4.8,4-7.6,2.6C337.6,199.5,336.9,199,336.4,198.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315.7,107.4c0.2-0.8,0.5-1.7,1.1-2.4c2-2.4,5.5-2.9,8-0.9c1.8,1.4,2.5,3.7,2,5.8c-0.5,2.1-2.1,3.8-4.3,4.4 c-3.1,0.7-6.1-1.2-6.8-4.3C315.5,109.2,315.5,108.3,315.7,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.8,115.8c2.3-1.1,4.8-1.7,7.5-1.7c0,0,0,0,0,0c0,0,0,0,0,0c2.7,0,5.2,0.6,7.5,1.7c2.3,1.1,4.3,2.7,6,4.8 c0,0,0,0,0,0c0,0,0,0,0,0c1.7,2.1,2.8,4.5,3.3,6.9c0.6,2.5,0.6,5.1,0,7.7c0,0,0,0,0,0s0,0,0,0c-0.6,2.6-1.8,5-3.3,6.9 c-1.6,2-3.6,3.6-6,4.8c0,0,0,0,0,0c0,0,0,0,0,0c-2.4,1.2-5,1.7-7.5,1.7c-2.5,0-5.1-0.6-7.5-1.7c0,0,0,0,0,0c0,0,0,0,0,0 c-2.4-1.2-4.4-2.8-6-4.8c-1.6-2-2.7-4.3-3.3-6.9c0,0,0,0,0,0s0,0,0,0c-0.6-2.6-0.6-5.2,0-7.7c0.6-2.5,1.7-4.8,3.3-6.9c0,0,0,0,0,0 s0,0,0,0C408.5,118.5,410.6,116.9,412.8,115.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.9,27.1C98,41.9,87.5,67.6,84.2,91.1C73.5,80.8,60,73.5,43.1,70.8c-7.9,13.9-13.2,37.7-8.6,61.2 c-8.9-2.3-17.5-3.1-25.2-1.9c0.5,58.6,58.7,91.4,111.7,70.9c53,20.5,111.2-12.3,111.7-70.9c-7.7-1.2-16.3-0.4-25.2,1.9 c4.6-23.5-0.7-47.3-8.6-61.2c-16.9,2.7-30.4,10.1-41.1,20.4C154.4,67.6,143.8,41.9,120.9,27.1z M24.8,147.4c0,0,10.7,0.7,16.9,5.2 c4.4,10.7,24,36.4,48.9,40C47.9,203.3,25.7,169.5,24.8,147.4z M151.3,192.6c24.9-3.6,44.4-29.3,48.9-40c6.2-4.4,16.9-5.2,16.9-5.2 C216.2,169.5,193.9,203.3,151.3,192.6z M57.4,151.9c-10.6-21.2-10.2-42.7-2.9-54.2c12.9,2.9,31.1,20.8,40.5,41.6 c4.4,9.8,11.6,29.3,13.3,46.2C79.9,187.3,64.1,165.4,57.4,151.9z M133.5,185.5c1.8-16.9,8.9-36.4,13.3-46.2 c9.4-20.8,27.6-38.6,40.5-41.6c7.3,11.5,7.7,33-2.9,54.1C177.7,165.4,162,187.3,133.5,185.5z M120.9,173.1 c-27.7-45.3-21.2-93.6,0-106.6C142.1,79.5,148.6,127.7,120.9,173.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 15.1,
    cy: 109.1,
    r: 10.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 226.8,
    cy: 109.1,
    r: 10.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 72.8,
    cy: 53.5,
    rx: 17.3,
    ry: 17.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3827 -0.9239 0.9239 0.3827 54.8996 189.26)",
    className: "st1",
    cx: 169.1,
    cy: 53.5,
    rx: 17.3,
    ry: 17.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M120.9,223.7c-3.8,0-19.9-6.2-24-12.1c-0.4-0.5,15-1.7,24-5.8c9,4.1,24.3,5.1,24,5.6 C140.7,217.2,124.8,223.7,120.9,223.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLotus);
export default __webpack_public_path__ + "static/media/lotus.f3c01e01f0dc44cda8b7e41b943c8a57.svg";
export { ForwardRef as ReactComponent };